"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const OrderIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.649 1A.658.658 0 000 1.667c0 .368.29.666.649.666h1.598c.294 0 .552.203.627.495l2.21 8.516c.152.583.667.99 1.255.99h.799c-.717 0-1.298.596-1.298 1.333 0 .736.581 1.333 1.298 1.333.717 0 1.298-.597 1.298-1.333 0-.737-.581-1.334-1.298-1.334h5.191c-.716 0-1.298.597-1.298 1.334 0 .736.582 1.333 1.298 1.333.717 0 1.298-.597 1.298-1.333 0-.737-.58-1.334-1.298-1.334h1.947a.658.658 0 00.649-.666.658.658 0 00-.649-.667H6.34l-.346-1.333h7.8c.287 0 .54-.193.622-.475l1.557-5.334c.125-.428-.187-.858-.621-.858H4.262l-.134-.515C3.901 1.609 3.13 1 2.248 1h-1.6z"
  })))
});
OrderIcon.displayName = 'OrderIcon';
var _default = exports.default = OrderIcon;